import { Box, Grid } from "@mui/material";
import { useComment } from "@platformx/authoring-apis";
import { CommentWrapper } from "@platformx/comment-review";
import { ErrorMessageHandle } from "@platformx/schema-based-content-type";
import { BasicSwitchText, CommonBoxWithNumber, TitleSubTitle } from "@platformx/utilities";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useCustomStyle } from "../../Poll.style";
import { Options } from "./Options";

const AnswerContent = ({
  showGallery,
  answers,
  setAnswers,
  addImage,
  setAddImage,
  qusUnsavedChanges,
  isError,
  setIsError,
}) => {
  const { t } = useTranslation();
  const [isDisable] = useState<boolean>(false);
  const { scrollToRef } = useComment();
  const handleChange = (event) => {
    setAddImage(event.target.checked);
  };
  const classes = useCustomStyle();
  return (
    <Box className={classes.mainStyleWrapper} id='answerContent'>
      <CommentWrapper elementId='4' scrollRef={scrollToRef}>
        <CommonBoxWithNumber
          number='04'
          title={t("answer_content")}
          titleVarient='h5bold'
          subTitleVarient='p4regular'
          subTitle={t("subhead")}>
          <Box className='textFiled'>
            <BasicSwitchText
              state={addImage}
              isDisable={isDisable}
              handleChange={handleChange}
              title={t("anwer_title")}
              subtitle={t("anwer_subtitle")}
              keyName='addImage'
              child={t("add_image")}
            />
          </Box>
          <Grid container>
            <Grid item xs={12} md={5} className='leftFiledLast'>
              <TitleSubTitle
                title={t("answers")}
                subTitle={t("enter_answer")}
                titleVariant='h6medium'
                subTitleVariant='p4regular'
              />
            </Grid>
            <Grid item xs={12} md={7} className='textFiledLast'>
              <Options
                addImage={addImage}
                showGallery={showGallery}
                answers={answers}
                setAnswers={setAnswers}
                qusUnsavedChanges={qusUnsavedChanges}
                isError={isError}
                setIsError={setIsError}
              />
              {(isError["emptyAnswers"] || isError["emptyImageOptions"]) && (
                <ErrorMessageHandle
                  error={{ message: addImage ? "Answer image is required" : "Field is Required" }}
                />
              )}
            </Grid>
          </Grid>
        </CommonBoxWithNumber>
      </CommentWrapper>
    </Box>
  );
};
export default AnswerContent;
